module.exports = __webpack_public_path__ + "3f2ab1ed238d7afb5a36f1f26c087b2f.svg";